import { 
    ETA_DELIVERY_RATE_REPORT,
    ETA_DELIVERY_RATE_REPORT_SUCCESS,
    ETA_DELIVERY_RATE_REPORT_FAIL,
    GET_ETA_DELIVERY_RATE_REPORT,
    GET_ETA_DELIVERY_RATE_REPORT_SUCCESS,
    GET_ETA_DELIVERY_RATE_REPORT_FAIL
} from '../actions/types';

const initialState = {
    etaDeliveryRateReportLoading: false,
    etaDeliveryRateReport: [],
    etaDeliveryRateReportError: false,
    getEtaDeliveryRateReportLoading: false,
    getEtaDeliveryRateReport: [],
    getEtaDeliveryRateReportError: false,
}

export default function edrrReducer(state = initialState, action){
    switch(action.type){
        case ETA_DELIVERY_RATE_REPORT:
            return {
                ...state,
                etaDeliveryRateReportLoading: true,
            }
        case ETA_DELIVERY_RATE_REPORT_SUCCESS:
            return {
                ...state,
                etaDeliveryRateReport: action.payload,
                etaDeliveryRateReportLoading: false
            }
        case ETA_DELIVERY_RATE_REPORT_FAIL:
            return {
                ...state,
                etaDeliveryRateReportLoading: false,
                etaDeliveryRateReportError: action.payload
            }
        case GET_ETA_DELIVERY_RATE_REPORT:
            return {
                ...state,
                getEtaDeliveryRateReportLoading: true,
            }
        case GET_ETA_DELIVERY_RATE_REPORT_SUCCESS:
            return {
                ...state,
                getEtaDeliveryRateReport: action.payload,
                getEtaDeliveryRateReportLoading: false
            }
        case GET_ETA_DELIVERY_RATE_REPORT_FAIL:
            return {
                ...state,
                getEtaDeliveryRateReportLoading: false,
                getEtaDeliveryRateReportError: action.payload
            }
        default:
            return state;
    }
}